import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isOrderButtonEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('activateOrderButton'),
)

export default isOrderButtonEnabledSelector
